// NOTE
// Please use your own firebase details below. For more details visit: https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html

//STAGING
import firebase from 'firebase/app'
import 'firebase/firestore';
// Initialize Firebase
const config = {
    apiKey: "AIzaSyBTCZu4VW-99Vz-8j5fTJ68cFH9KOXnI8g",
    authDomain: "macro-topic-496.firebaseapp.com",
    databaseURL: "https://macro-topic-496.firebaseio.com",
    projectId: "macro-topic-496",
    storageBucket: "macro-topic-496.appspot.com",
    messagingSenderId: "381539348753",
    appId: "1:381539348753:web:4acd999686350b2ef95cb0"
}
firebase.initializeApp(config)


